<button type="button" [class]="buttonClass + ' ' + guestClass"  (click)="onClick($event)" [title]="title"
  [disabled]="disabled" [attr.aria-disabled]="ariaDisabled">
   <ng-container *ngIf="!hideText">{{text}}</ng-container>
   <ng-container *ngIf="!hideText && icon || working">&nbsp;</ng-container>
   <app-spinner size="s" *ngIf="working"></app-spinner>
   <span *ngIf="icon && !working" [class]="iconClass" aria-hidden="true"></span>
</button>